import { Paper, Stack, Typography } from "@mui/material";
import { Fragment, useContext } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import GoBack from "../../../../components/buttons/GoBack";
import SimpleAlert from "../../../../components/display/SimpleAlert";
import UserVerification from "../../../../components/display/UserVerification";
import Skeletons from "../../../../components/loader/Skeletons";
import PageContentWrapper from "../../../../components/wrappers/PageContentWrapper";
import { GlobalDataContext } from "../../../../contexts/GlobalData";
import { CHANGE_CLINIC_EMPLOYEE } from "../../../../enums/PermissionTitles";
import { SINGLE_EMPLOYEE } from "../../../../enums/UrlPaths";
import { useGetSingleUserPermissions } from "../../../../hooks/useGetSingleUserPermissions";
import UserActionsMenu from "../../users/components/UserActionsMenu";
import UserPermissionsPage from "../UserPermissionsPage";
import UserGeneralInformationDisplay from "./UserGeneralInformationDisplay";
import UserLocationDisplay from "./UserLocationDisplay";
import { useRedirectIfNotOwnClinic } from "../../../../hooks/useRedirectIfNotOwnClinic";

export default function SingleUserPermission() {
  const { id } = useParams();
  const { data, loading, error } = useGetSingleUserPermissions(id);
  useRedirectIfNotOwnClinic(data?.user?.clinic?.id, loading || !data);
  const { isPermissionAllowed } = useContext(GlobalDataContext);
  const { t } = useTranslation();
  const navigate = useNavigate();

  if (loading) {
    return <Skeletons numOfSkeletons={6} />;
  } else if (error) {
    <SimpleAlert
      message={"CouldntFetchUserInformationAtThisTime"}
      severity={"error"}
    />;
  }

  return (
    <PageContentWrapper>
      <Stack spacing={2}>
        <Fragment>
          <Stack
            direction={"row"}
            spacing={2}
            margin={1}
            justifyContent={"space-between"}
          >
            <Stack direction={"row"} spacing={2}>
              <GoBack />
              <Typography variant="h5">{t("UserInformation")}</Typography>
            </Stack>
            <Stack direction="row" spacing={3} alignItems="center">
              <UserVerification data={data?.user} />
              <UserActionsMenu
                userId={id}
                email={data?.user?.userDetails?.email}
                active={data?.user?.active}
                role={data?.user?.role}
                onEdit={() => navigate(SINGLE_EMPLOYEE + id)}
                canEdit={isPermissionAllowed(CHANGE_CLINIC_EMPLOYEE)}
                editLabel="EditEmployee"
                editDescription="EditEmployeeDetails"
                menuTitle="EmployeeActions"
                showResetPassword
              />
            </Stack>
          </Stack>
          <UserGeneralInformationDisplay />
          <UserLocationDisplay />
        </Fragment>
        <Paper sx={{ p: 2 }}>
          <Typography variant="h5">{t("UserPermissions")}</Typography>
          <UserPermissionsPage
            user={data?.user}
            permissions={data?.permissions}
          />
        </Paper>
      </Stack>
    </PageContentWrapper>
  );
}
